import { useEffect, useState } from 'react';
export const useObserveHeights = (objectPage, topHeader, headerContentRef, anchorBarRef, { noHeader }) => {
    var _a, _b;
    const [topHeaderHeight, setTopHeaderHeight] = useState(0);
    const [headerContentHeight, setHeaderContentHeight] = useState(0);
    const [isIntersecting, setIsIntersecting] = useState(true);
    useEffect(() => {
        const headerIntersectionObserver = new IntersectionObserver(([header]) => {
            if (header.isIntersecting) {
                setIsIntersecting(true);
            }
            else {
                setIsIntersecting(false);
                setHeaderContentHeight(0);
            }
        }, { rootMargin: `-${topHeaderHeight}px 0px 0px 0px`, root: objectPage === null || objectPage === void 0 ? void 0 : objectPage.current, threshold: 0.3 });
        if (headerContentRef === null || headerContentRef === void 0 ? void 0 : headerContentRef.current) {
            headerIntersectionObserver.observe(headerContentRef.current);
        }
        return () => {
            headerIntersectionObserver.disconnect();
        };
    }, [topHeaderHeight, setHeaderContentHeight, headerContentRef.current, setIsIntersecting]);
    // top header
    useEffect(() => {
        const headerContentResizeObserver = new ResizeObserver(([header]) => {
            var _a;
            // Firefox implements `borderBoxSize` as a single content rect, rather than an array
            const borderBoxSize = Array.isArray(header.borderBoxSize) ? header.borderBoxSize[0] : header.borderBoxSize;
            // Safari doesn't implement `borderBoxSize`
            setTopHeaderHeight((_a = borderBoxSize === null || borderBoxSize === void 0 ? void 0 : borderBoxSize.blockSize) !== null && _a !== void 0 ? _a : header.target.getBoundingClientRect().height);
        });
        if (topHeader === null || topHeader === void 0 ? void 0 : topHeader.current) {
            headerContentResizeObserver.observe(topHeader.current);
        }
        return () => {
            headerContentResizeObserver.disconnect();
        };
    }, [topHeader === null || topHeader === void 0 ? void 0 : topHeader.current, setTopHeaderHeight]);
    // header content
    useEffect(() => {
        const headerContentResizeObserver = new ResizeObserver(([headerContent]) => {
            var _a;
            if (isIntersecting) {
                // Firefox implements `borderBoxSize` as a single content rect, rather than an array
                const borderBoxSize = Array.isArray(headerContent.borderBoxSize)
                    ? headerContent.borderBoxSize[0]
                    : headerContent.borderBoxSize;
                // Safari doesn't implement `borderBoxSize`
                setHeaderContentHeight((_a = borderBoxSize === null || borderBoxSize === void 0 ? void 0 : borderBoxSize.blockSize) !== null && _a !== void 0 ? _a : headerContent.target.getBoundingClientRect().height);
            }
        });
        if (headerContentRef === null || headerContentRef === void 0 ? void 0 : headerContentRef.current) {
            headerContentResizeObserver.observe(headerContentRef.current);
        }
        return () => {
            headerContentResizeObserver.disconnect();
        };
    }, [headerContentRef === null || headerContentRef === void 0 ? void 0 : headerContentRef.current, setHeaderContentHeight, isIntersecting]);
    const anchorBarHeight = (_b = (_a = anchorBarRef === null || anchorBarRef === void 0 ? void 0 : anchorBarRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) !== null && _b !== void 0 ? _b : 33;
    const totalHeaderHeight = (noHeader ? 0 : topHeaderHeight + headerContentHeight) + anchorBarHeight;
    // necessary for dynamically changed font size of the title
    useEffect(() => {
        if (isIntersecting) {
            objectPage.current.scrollTop = 0;
        }
        if (!isIntersecting) {
            objectPage.current.scrollTop = totalHeaderHeight;
        }
    }, [isIntersecting, totalHeaderHeight]);
    return { topHeaderHeight, headerContentHeight, anchorBarHeight, totalHeaderHeight };
};
